export const COLOR = {
  DEFAULT: 'default',
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  SUCCESS: 'success',
  DANGER: 'danger',
  WARNING: 'warning'
};

export const ROUNDED = {
  EMPTY: 'empty',
  LOW: 'low',
  MORE: 'more',
  FULLY: 'fully'
};

export const SIZE = {
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large',
  XLARGE: 'xlarge'
};

export const SPINNER_RATIO = {
  small: .5,
  medium: .65,
  large: .8,
  xlarge: .95
};

export const TARGET = {
  BLANK: '_blank',
  SELF: '_self',
  PARENT: '_parent',
  TOP: '_top'
};

export const TYPE = {
  BUTTON: 'button',
  SUBMIT: 'submit',
  RESET: 'reset'
};

export const VARIANT = {
  CONTAINED: 'contained',
  OUTLINED: 'outlined',
  TEXT: 'text'
};
